/**
 * Compute purchase price from invoice line item data.
 * Priority: unitPrice > (lineTotal / qty) > lineTotal
 * All results rounded to 2 decimal places (currency).
 *
 * Reusable across PDF import, CSV import, email invoice import, etc.
 */
export function computePurchasePrice(
  unitPrice: number | null | undefined,
  lineTotal: number | null | undefined,
  qty: number | null | undefined
): number | null {
  if (unitPrice != null && unitPrice > 0)
    return Math.round(unitPrice * 100) / 100;
  if (lineTotal != null && qty != null && qty > 0)
    return Math.round((lineTotal / qty) * 100) / 100;
  if (lineTotal != null && lineTotal > 0)
    return Math.round(lineTotal * 100) / 100;
  return null;
}
